import React, { useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import "./login.css";
import { getNodeApiBase } from "../utils/apiBase";

const PassReset = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nodeApiBase = getNodeApiBase();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);
    try {
      // Replace with your actual API endpoint for password reset
      const response = await axios.post(`${nodeApiBase}/api/send-reset-link`, {
        email,
      });
      if (response.data.success) {
        setMessage(
          "Un lien de réinitialisation a été envoyé à votre adresse e-mail si elle est valide."
        );
      } else {
        setError(response.data.message || "Adresse e-mail non trouvée.");
      }
    } catch (err) {
      setError("Erreur lors de l'envoi du lien. Veuillez réessayer.");
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-content">
          <form onSubmit={handleSubmit}>
            <p>Réinitialiser le mot de passe</p>
            <div className="input-container">
              <label htmlFor="email">E-mail</label>
              <input
                name="email"
                type="email"
                placeholder="Entrez votre e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>
            <div className="button-container">
              <button type="submit" disabled={loading}>
                {loading ? "Envoi..." : "Envoyer le lien"}
              </button>
            </div>
            {message && <div className="success-message">{message}</div>}
            {error && <div className="error-message">{error}</div>}
          </form>
        </div>
        <div className="account-link">
          <Link to="/login">
            <span>Retour à la connexion</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PassReset;
